import lang from "@/views/modules/Comments/language/en";
//import Editor from '@tinymce/tinymce-vue';
export default {
    name: "edit-comment",
    components: {
//        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            comment: {},
            lang:[],
        }
    },
    mounted() {
        this.getComment();
        this.lang = lang;
    },
    methods: {
        saveComment() {
            const self = this;
            self.loading = true;
            axios.put('api/modules/comments/' + self.$route.params.id, self.comment).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getComment() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/comments/' + self.$route.params.id).then(function (response) {
                self.comment = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        
    }
}